import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

export const JornadasProcesoGerente = () => {
  const [jornadas, setJornadas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fetchJornadas = async () => {
      try {
        const res = await fetch(Global.url + "jornadas/proceso", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.ok) {
          const data = await res.json();
          setJornadas(data);
        } else {
          setMensaje("No se pudieron obtener las jornadas en proceso.");
        }
      } catch (error) {
        console.error("Error al cargar las jornadas:", error);
        setMensaje("Error de conexión con el servidor.");
      }
    };

    const fetchUsuarios = async () => {
      try {
        const res = await fetch(Global.url + "usuarios", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (res.ok) {
          const data = await res.json();
          setUsuarios(data);
        }
      } catch (error) {
        console.error("Error al cargar los usuarios:", error);
      }
    };

    fetchJornadas();
    fetchUsuarios();
  }, []);

  const getNombreCompleto = (usuario_id) => {
    const u = usuarios.find(u => u.id === usuario_id);
    return u ? `${u.nombre} ${u.apellidos || ""}` : "-";
  };

  return (
    <div className="consulta-ticajes">
      <h2 className="centrar-titulo">Jornadas en Proceso</h2>
      {mensaje && <p className="rojo">{mensaje}</p>}

      {jornadas.length === 0 ? (
        <p>No hay jornadas activas actualmente.</p>
      ) : (
        <table className="table-listado">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Cliente</th>
              <th>Centro</th>
              <th>Inicio</th>
              <th>Comentarios</th>
            </tr>
          </thead>
          <tbody>
            {jornadas.map((j) => (
              <tr key={j.id}>
                <td>{getNombreCompleto(j.usuario_id)}</td>
                <td>{j.cliente}</td>
                <td>{j.centro}</td>
                <td>{new Date(j.fecha_inicio).toLocaleString()}</td>
                <td>{j.comentarios || "Sin comentarios"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
